export default __webpack_public_path__ + "static/media/dont_get_mad_at_donkey_kong.57662ebc.png";